import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const backupServicePlugin = createPlugin({
  id: 'backup-service',
  routes: {
    root: rootRouteRef,
  },
});

export const BackupServicePage = backupServicePlugin.provide(
  createRoutableExtension({
    name: 'BackupServicePage',
    component: () =>
      import('./components/BackupServiceComponent').then(m => m.BackupServiceComponent),
    mountPoint: rootRouteRef,
  }),
);
